<template>
  <div>
    <Header />
    <b-container>
      <Breadcrumb />
      <b-row>
        <b-col cols="12" lg="2" class="mypage__sidebar mypage__sidebar-mb">
          <SidebarMypage />
        </b-col>
        <b-col cols="12" lg="1"></b-col>
        <b-col cols="12" lg="8">
          <b-navbar class="mypage__navbar">
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav>
                <b-nav-item href="#" class="mypage__navlink"><span class="mypage__statistic">合計</span><span class="mypage__statistic__number mypage__statistic__number__green">30</span></b-nav-item>
                <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">PDF</span><span class="mypage__statistic__number mypage__statistic__number__pink">30</span></b-nav-item>
                <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">画像</span><span class="mypage__statistic__number mypage__statistic__number__blue">30</span></b-nav-item>
                <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">動画</span><span class="mypage__statistic__number mypage__statistic__number__purple">30</span></b-nav-item>
              </b-navbar-nav>
              <b-navbar-nav class="ml-auto">
                <button class="btn--filter"><i class="icon-i-list"></i></button>
                <button class="btn--filter btn--filter--green"><i class="icon-i-grid"></i></button>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
          <!--<GridFiles />-->
          <ListFiles />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SidebarMypage from '@/views/Manager/MyPage/SidebarMypage'
import Header from '@/components/share/Header'
import Breadcrumb from '@/components/share/Breadcrumb'
import GridFiles from '@/components/Manager/FolderManagerment/GridFiles'
import ListFiles from '@/components/Manager/FolderManagerment/ListFiles'
export default {
  name: 'FavoriteMypage',
  components: {
    Header,
    SidebarMypage,
    Breadcrumb,
    GridFiles,
    ListFiles
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/MyPage/FavoriteMypage.vue